<template>
  <div class="gallery">
    <figure
      v-for="(image, idx) in images"
      :key="idx"
      class="gallery__item"
      :class="[`gallery__item--${idx}`]"
      @click="imageClicked(idx)"
    >
      <img :src="image" :alt="imageAlt" class="gallery__img" />
    </figure>
  </div>
</template>

<script>
export default {
  name: 'GalleryAbus',
  props: {
    images: {
      type: Array,
      required: true,
    },
    imageAlt: {
      type: String,
      default: 'rizes-house halkidiki',
    },
  },
  methods: {
    imageClicked(idx) {
      this.$emit('imageIndx', idx);
    },
  },
};
</script>

<style scoped lang="scss">
.gallery {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: repeat(7, 5vw);
  grid-gap: 7px;
  padding: 10px;

  &__item {
    &--0 {
      grid-row: 1 / span 2;
      grid-column: 1 / span 2;
    }
    &--1 {
      grid-row: 1 / span 3;
      grid-column: 3 / span 3;
    }
    &--2 {
      grid-row: 1 / span 2;
      grid-column: 6 / span 1;
    }
    &--3 {
      grid-row: 1 / span 2;
      grid-column: 7 / span 2;
    }
    &--4 {
      grid-row: 3 / span 3;
      grid-column: 1 / span 2;
    }
    &--5 {
      grid-row: 4 / span 2;
      grid-column: 3 / span 2;
    }
    &--6 {
      grid-row: 4 / span 1;
      grid-column: 5 / span 1;
    }
    &--7 {
      grid-row: 3 / span 2;
      grid-column: 6 / span 2;
    }
    &--8 {
      grid-row: 3 / span 3;
      grid-column: 8 / span 1;
    }
    &--9 {
      grid-row: 6 / span 2;
      grid-column: 1 / span 1;
    }
    &--10 {
      grid-row: 6 / span 2;
      grid-column: 2 / span 2;
    }
    &--11 {
      grid-row: 6 / span 2;
      grid-column: 4 / span 1;
    }
    &--12 {
      grid-row: 5 / span 3;
      grid-column: 5 / span 3;
    }
    &--13 {
      grid-row: 6 / span 2;
      grid-column: 8 / span 1;
    }
  }

  &__img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    display: block;
  }
}

@media only screen and (max-width: 900) {
  .gallery {
    grid-gap: 5px;
  }
}

@media only screen and (max-width: 600px) {
  .gallery {
    grid-gap: 2px;
  }
}
</style>
